import { useCallback } from 'react';

import { Directory } from '@core/types/types.common';
import { useBroadcaster } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { DirectoryContext } from '@frontend/shared/hooks/useDirectory';
import { useRequiredContext } from '@frontend/shared/hooks/useRequiredContext';

export function useDirectoryUpdater() {
  const broadcast = useBroadcaster();
  const directory = useRequiredContext(DirectoryContext);

  return useCallback(
    (updates?: Partial<Directory> | null) => {
      if (!updates) {
        return;
      }

      broadcast({
        event: 'directory:save',
        directory: { ...directory, ...updates },
      });
    },
    [directory, broadcast],
  );
}
